import Text from '@shared/components/content/text';
import Unit from '@shared/components/content/unit';
import { capitalizeFirstLetter, cn, formatNumber } from '@shared/lib/utils';
import React from 'react';

interface PieChartLegendProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string;
  emissions: number;
  percentage: number;
  color: string;
  notIncluded?: boolean;
}

export default function PieChartLegend({
  name,
  emissions,
  percentage,
  color,
  notIncluded = false,
}: PieChartLegendProps) {
  return (
    <div className="mb-3 grid w-full grid-cols-12 items-center gap-1">
      <div className="col-span-4 flex items-center space-x-2 lg:col-span-5">
        <div
          className={cn(`size-6 rounded-sm`)}
          style={{
            backgroundColor: color,
          }}
        ></div>
        <Text className="text-md">{capitalizeFirstLetter(name)}</Text>
      </div>
      {notIncluded ? (
        <div className="col-span-7 flex justify-end">
          <Text variant="reportBody" className="text-primary-400">
            Not included
          </Text>
        </div>
      ) : (
        <div className="col-span-7 grid grid-cols-12 items-baseline gap-6 space-x-3">
          <div className="col-span-6 flex items-baseline justify-end space-x-1 ">
            <Text variant="reportBody">{formatNumber(emissions)}</Text>
            <Unit variant="tCO2e" />
          </div>

          <div className="col-span-6 flex items-baseline justify-end space-x-1">
            <Text variant="reportBody">{percentage}</Text>
            <Unit variant="% of emissions" className=" text-nowrap" />
          </div>
        </div>
      )}
    </div>
  );
}
